import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import history from "../../services/history";
import { loginWithTokenByRedirect, removeCacheForLogin } from "../../store/modules/auth/actions";
import {
	getMicroServiceDetailFluxPromo,
	// getPlanDetailFluxPromo,
	onGetBillingPlansRequest,
	selectedPlanRequest,
	selectedPlanSuccess,
} from "../../store/modules/billingPlan/actions";
import { initialStateCheck } from "../../store/modules/sessionStorage/actions";
import {
	ButtonOpenAccount,
	Container,
	ContainerButton,
	Content,
	PlanName,
	SubmitButtom,
	Title,
	Wrapper,
} from "./styles";
import { getSessionStorageKey } from "../../utils";
import Loading from "../../components/Loading";

export default function Contrate() {
	const dispatch = useDispatch();
	const { plan, idservice, id_research, cd_promotional, cdcombo, combo_promotional, id_influencer } =
		useParams();

	const [selectedPlan, setSelectedPlan] = useState(undefined);
	const [paramsQuery] = useState(new URLSearchParams(useLocation().search));
	const [plansAvailable] = useState(["explorer", "prime", "pro", "trademap_educa_jovens", "eleven"]);
	const [token, setToken] = useState(null);
	const [namePlan, setNamePlan] = useState("");

	const { listPlan, isFluxPromotional, loading } = useSelector((state) => state.billingPlan);
	const { authenticated } = useSelector((state) => state.auth);

	useEffect(() => {
		dispatch(initialStateCheck("contrate"));
		dispatch(removeCacheForLogin(false));

		if (
			!plansAvailable.includes(plan) &&
			!idservice &&
			!cd_promotional &&
			!cdcombo &&
			!combo_promotional
		)
			planErrorHander();

		if (cd_promotional) {
			const action = {
				product: cd_promotional ? "Plan" : "Combo",
				cdPromotional: cd_promotional || combo_promotional,
			};
			fluxPromotional(action);
		}

		if (id_influencer || paramsQuery.get("id_influencer")) {
			const id = id_influencer ? id_influencer : paramsQuery.get("id_influencer");
			localStorage.setItem("FLUX_INFLUENCER", id);
		}

		if (paramsQuery.get("id_combo")) {
			localStorage.setItem("id_combo", paramsQuery.get("id_combo"));
		}

		if (paramsQuery.get("cd_combo")) {
			localStorage.setItem("cd_combo", paramsQuery.get("cd_combo"));
		}

		if (cdcombo) {
			localStorage.setItem("cd_combo", cdcombo);
			localStorage.setItem("flow-checkout", "CHECKOUT");
		}

		if (plan) {
			localStorage.setItem("flow-checkout-plan", "CHECKOUT_PLAN");
		}

		combo_promotional
			? sessionStorage.setItem("COMBO_PROMOTIONAL", combo_promotional)
			: sessionStorage.removeItem("COMBO_PROMOTIONAL");

		if (idservice && !isNaN(parseInt(idservice))) {
			localStorage.setItem("flow-checkout-id", btoa(idservice));
		} else if (idservice) {
			toast.error("Endereço invalido.");
			history.push("/onboard/login");
			return <Container />;
		}

		const regexToken = /\{[^}]*\}/g;
		const tokenLogin = !regexToken.test(paramsQuery.get("token")) ? paramsQuery.get("token") : null;

		setToken(tokenLogin);
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (window.location.pathname.includes("promo") && !token) {
			if (isFluxPromotional) {
				history.push(
					`/onboard/login?flux-promotional=${
						cd_promotional || combo_promotional
					}`
				);
			}
		}
		// eslint-disable-next-line
	}, [isFluxPromotional]);

	useEffect(() => {
		const CLIENT_AUTH = getSessionStorageKey("CLIENT_AUTH");
		const routeMicroService = namePlan.includes("COMBO") ? "combo" : "plano";

		let id_research_selected = id_research;
		if (selectedPlan) {
			const { researches } = selectedPlan;
			if (Boolean(researches.length)) {
				const { researches } = selectedPlan;
				if (researches.length) id_research_selected = researches[0];
			}

			localStorage.setItem("CACHEDPLAN", JSON.stringify(selectedPlan));
		}

		if (token && !authenticated) {
			if (cd_promotional && !selectedPlan) return;
			if (Boolean(CLIENT_AUTH)) sessionStorage.removeItem("CLIENT_AUTH");

			dispatch(
				loginWithTokenByRedirect({
					selected_plan: selectedPlan,
					id_research: id_research_selected,
					cd_promotional,
					token,
					redirect: `/onboarding/carrinho/${routeMicroService}`,
				})
			);
		}
		// eslint-disable-next-line
	}, [token, authenticated, selectedPlan, id_research, cd_promotional]);

	useEffect(() => {
		if (!cd_promotional) {
			dispatch(onGetBillingPlansRequest(null));
		}
	}, [cd_promotional]);

	useEffect(() => {
		if (plan) {
			const cd_plan = plan.toUpperCase();
			const plan_selected = listPlan.find((item) =>
				cd_plan.toUpperCase().includes(item.cd_plan.toUpperCase())
			);
			setSelectedPlan(plan_selected);
			dispatch(selectedPlanSuccess(plan_selected));
		}
		// eslint-disable-next-line
	}, [listPlan, plan]);

	useEffect(() => {
		if (plan) {
			setNamePlan(plan.toUpperCase());
			return;
		}

		setNamePlan("COMBOS");
	}, [plan]);

	function fluxPromotional(param) {
		localStorage.setItem(
			"FLUX_PROMO",
			JSON.stringify({
				isPromo: true,
				route: window.location.pathname,
			})
		);

		const callAction = {
			Plan: () => {
				// dispatch(getPlanDetailFluxPromo(param.cdPromotional))
				dispatch(onGetBillingPlansRequest(null, param.cdPromotional));
			},
			Combo: () => dispatch(getMicroServiceDetailFluxPromo(param.cdPromotional)),
		};
		if (window.location.pathname.includes("promo")) {
			callAction[param.product]();
		}
	}

	function imAlreadyUser(hasAccount = false) {
		if (idservice || cdcombo || combo_promotional) {
			localStorage.setItem("flow-checkout", "CHECKOUT");
			selectAppFlow(hasAccount);
		} else {
			selectPlan(hasAccount);
		}
	}

	function selectPlan(hasAccount = false) {
		if (!selectedPlan) {
			planErrorHander();
			return;
		}

		localStorage.setItem("CACHEDPLAN", JSON.stringify(selectedPlan));
		dispatch(selectedPlanRequest(selectedPlan, false, null, cd_promotional));
		selectAppFlow(hasAccount);
	}

	function selectAppFlow(hasAccount) {
		if (hasAccount) {
			const path = getPathRedirectOnboard();
			localStorage.setItem("appflow", "RECOVER");
			history.push(path);
		} else {
			localStorage.setItem("appflow", "REGISTER");
			history.push("/onboard/welcome");
		}
	}

	function getPathRedirectOnboard() {
		const campaignAction = {
			LOGIN: "/onboard/login",
		};

		return campaignAction.LOGIN;
	}

	function planErrorHander() {
		toast.error("Não foi possível selecionar o plano.");
		history.push("/onboard/login");
	}

	return (
		<Container>
			{loading ? (
				<Loading newLoading={true} />
			) : (
				<Content>
					<Wrapper>
						<Title>TradeMap</Title>
						<PlanName>{namePlan}</PlanName>
					</Wrapper>
					<ContainerButton>
						<SubmitButtom onClick={() => imAlreadyUser(false)}>
							Criar uma conta
						</SubmitButtom>
						<ButtonOpenAccount onClick={() => imAlreadyUser(true)}>
							Entrar na minha conta
						</ButtonOpenAccount>
					</ContainerButton>
				</Content>
			)}
		</Container>
	);
}
